/* Campagnepagina's: toont de sticky bar zodra je voorbij het eerste scherm scrolt.
   Zet ook body.sf-sticky-on, hetzelfde mechanisme dat sf-studios.js gebruikt om de
   chatbubbel (Tidio/Gorgias/Intercom/Trengo/...) boven de sticky balk te houden — zonder
   die class overlapt de chatbubbel de CTA-knop in de sticky bar op mobiel. */
(function () {
  function init() {
    var bar = document.querySelector('[data-sf-campaign-sticky]');
    if (!bar) return;
    var threshold = Math.round(window.innerHeight * 0.8);
    var ticking = false;
    function update() {
      var show = window.scrollY > threshold;
      bar.classList.toggle('visible', show);
      document.body.classList.toggle('sf-sticky-on', show);
      ticking = false;
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      threshold = Math.round(window.innerHeight * 0.8);
    });
    update();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
